import URLS from '@/server/urls';
import { POST } from '@/server/http';
export default async ({
  role,
  api,
  perm = 0 // 1 = allow, 0 = deny
}, options = {
  showError: true
}) => {
  const [content, error, status] = await POST(URLS.perms.setPerm, {
    role,
    api,
    perm
  }, options);
  if (error) return {
    error,
    status
  };
  return content || {};
};